var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.humanise)?_c('span',{staticClass:"be-date"},[_vm._v(_vm._s(_vm.formatDate(_vm.date, _vm.format)))]):_c('span',{staticClass:"be-date"},[_vm._v(_vm._s(_vm.humanizeDate(_vm.date)))])}
var staticRenderFns = []

export { render, staticRenderFns }